// Replace with your real third-party booking link (Fresha / Square etc.). Empty = scroll to booking section.
export const BOOKING_URL = '';

// Replace with a real Google Maps link once the address is confirmed. Empty = no directions link shown.
export const DIRECTIONS_URL = '';

export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'Artists', href: '/artists' },
  { label: 'Selected Work', href: '/work' },
  { label: 'Visit', href: '/visit' },
];

export const lookSlugs = ['copper-dimension', 'precision-bob', 'platinum-glow', 'soft-rose', 'sculpted-curls', 'violet-veil'];

export const workFilters = ['All', 'Colour', 'Cut', 'Texture'];

export const lookDetails = [
  { title: 'Copper Dimension', category: 'Colour', service: 'Creative Colour', desc: 'Layered warm copper tones that add depth and movement to long waves.' },
  { title: 'Precision Bob', category: 'Cut', service: 'Cut & Style', desc: 'A blunt, chin-length line cut for a sharp, polished outline.' },
  { title: 'Platinum Glow', category: 'Colour', service: 'Creative Colour', desc: 'Even, icy platinum lightening finished with a cool tone.' },
  { title: 'Soft Rose', category: 'Colour', service: 'Creative Colour', desc: 'A pastel rose shade over soft collarbone-length layers.' },
  { title: 'Sculpted Curls', category: 'Texture', service: 'Cut & Style', desc: 'A rounded curl shape cut to support natural coil definition.' },
  { title: 'Violet Veil', category: 'Cut', service: 'Cut & Style', desc: 'A textured shag cut paired with a muted lilac-violet colour.' },
];

export const stylistBios = [
  'Mara leads creative direction at NOVA. Her chair is the place for precise shapes and complete restyles planned around your texture.',
  'Theo works mainly in colour, from soft hand-painted balayage to bolder creative shades.',
  'Ines focuses on curls and natural texture, cutting and styling to work with your hair rather than against it.',
];

export const serviceTiers = ['Stylist', 'Senior', 'Creative Director'];

export const serviceGroups = [
  {
    id: 'cut',
    title: 'Cut & Style',
    note: 'Includes consultation, wash and finish.',
    items: [
      { name: 'Signature Cut', desc: 'Precision cut tailored to texture and face shape.', time: '60 min', prices: ['$XX', '$XX', '$XX'] },
      { name: 'Restyle Consultation & Cut', desc: 'A full change of shape, planned together.', time: '90 min', prices: ['$XX', '$XX', '$XX'] },
      { name: 'Blow-Dry & Finish', desc: 'Smooth, volume or soft editorial texture.', time: '45 min', prices: ['$XX', '$XX', '$XX'] },
    ],
  },
  {
    id: 'colour',
    title: 'Creative Colour',
    note: 'Skin test required 48 hours before first colour.',
    items: [
      { name: 'Hand-Painted Balayage', desc: 'Soft, lived-in light placed by hand.', time: '90 min+', prices: ['$XX', '$XX', '$XX'] },
      { name: 'Vivid & Creative Colour', desc: 'Copper, rose, silver or bold fashion shades.', time: '90 min+', prices: ['$XX', '$XX', '$XX'] },
      { name: 'Gloss & Tone', desc: 'Shine, depth and tone correction.', time: '45 min', prices: ['$XX', '$XX', '$XX'] },
    ],
  },
  {
    id: 'treat',
    title: 'Treatment & Care',
    note: 'Can be added to any cut or colour service.',
    items: [
      { name: 'Bond Repair Ritual', desc: 'Rebuilds strength after lightening.', time: '30 min', prices: ['$XX', '$XX', '$XX'] },
      { name: 'Scalp Reset', desc: 'Exfoliating cleanse and massage.', time: '30 min', prices: ['$XX', '$XX', '$XX'] },
    ],
  },
];

// Optimized WebP assets (Phase 04A)
export const studioImage = 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-studio-interior.webp';

export const looks = [
  { title: 'Copper Dimension', tag: 'Creative Colour · Warm Copper', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-look-copper-dimension.webp' },
  { title: 'Precision Bob', tag: 'Cut & Style · Blunt Bob', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-look-precision-bob.webp' },
  { title: 'Platinum Glow', tag: 'Lightening · Icy Platinum', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-look-platinum-glow.webp' },
  { title: 'Soft Rose', tag: 'Creative Colour · Pastel Rose', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-look-soft-rose.webp' },
  { title: 'Sculpted Curls', tag: 'Cut & Texture · Curl Definition', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-look-sculpted-curls.webp' },
  { title: 'Violet Veil', tag: 'Creative Colour · Lilac Violet', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-look-violet-veil.webp' },
];

export const stylists = [
  { name: 'Mara Ellison', first: 'Mara', role: 'Creative Director', specialty: 'Precision cutting and restyles', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-team-mara.webp' },
  { name: 'Theo Marchetti', first: 'Theo', role: 'Senior Colourist', specialty: 'Balayage and creative colour', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-team-theo.webp' },
  { name: 'Ines Okafor', first: 'Ines', role: 'Texture Specialist', specialty: 'Curls and natural texture', src: 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-team-ines.webp' },
];

export const bookingImage = 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-booking-chignon.webp';

export const visitImage = 'https://public.readdy.ai/ai/img_res/sandbox/70cd55af4e0fec2bc79e4ad21ea00075/a8e89613-9631-482a-96db-800ab7685863_nova-visit-reception.webp';

export const hours = [
  { day: 'Monday', time: 'Closed' },
  { day: 'Tue – Fri', time: '[Opening hours]' },
  { day: 'Saturday', time: '[Opening hours]' },
  { day: 'Sunday', time: '[Opening hours]' },
];